export default __webpack_public_path__ + "static/media/259.e87a557a.jpg";